import React from 'react';
import Button from '../Button';

const FormSuccess = ({message, onClick}) => {
  if (!message) {
    return null;
  }
  return (
    <div>
      <div className="alert alert-success">
        {message}
      </div>
      <Button text="button.ok" onClick={onClick}/>
    </div>
  );
};

FormSuccess.propTypes = {
  message: React.PropTypes.string.isRequired,
  onClick: React.PropTypes.func
};

export default FormSuccess;



// WEBPACK FOOTER //
// ./src/js/Component/Form/FormSuccess.jsx